const translations = {
    aging: 'Aging',
    cycleLife: 'Cycle Life',
    cycles: 'Cycles',
    cyclesValue: '{{used}} / {{total}} cycles',
    ok: 'OK',
    synced: 'Synced {{time}}',
    usedWith: 'Used with'
};

export default translations;
